module.exports = __webpack_public_path__ + "static/media/9.10f9fd76.jpg";